<template>
	<div>
		<div class="actDiv">
			<label>选择小区:</label>
			<a-select  style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="neighborId"
							placeholder="请选择小区"  option-filter-prop="children" 
							:filter-option="filterOption" show-search >
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">
					{{item.neighborName}}
				</a-select-option>
			</a-select>
			<a-select style="width:9rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="prePaySign"
				option-filter-prop="children" :filter-option="filterOption" show-search allowClear>
				<a-select-option v-for="(item,index) in payList" :value="item.value">{{item.label}}
				</a-select-option>
			</a-select>
			<a-button size="small" icon="search"    @click="searchIt" :loading="loading" >查询</a-button>
		</div>
		<vxe-table  align="center" :data="changeLogList"  border height="500"  ref="mTable" show-overflow="title" size="mini" 
						  resizable highlight-hover-row :loading="loading"    row-id="id">
				<vxe-table-column type="seq" width="45"></vxe-table-column>
				<vxe-table-column title="所属小区" field="neighbor_id"  :formatter="getTheNeighbor"></vxe-table-column>
				<vxe-table-column title="用户号" field="customer_num" ></vxe-table-column>
				<vxe-table-column title="预后付费(转换后)" field="prepay_sign"  :formatter="getPrePaySign"></vxe-table-column>
				<vxe-table-column title="操作时间" field="create_time" :formatter="getTimeFormatter"></vxe-table-column>
				<vxe-table-column title="操作者" field="create_user_name"></vxe-table-column>
		</vxe-table>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loading:false,
				neighborId:null,
				prePaySign:null,
				changeLogList:[],
				neighborList:[],
				payList: [{
						value: 1,
						label: "预付费"
					},
					{
						value: 0,
						label: "后付费"
					},
				],
			}
		},
		methods:{
			getTheNeighbor({cellValue}){
				let result  = "";
				for(var i=0;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if (item.pId == cellValue){
						result = item.neighborName;
						break;
					}
				}
				return result;
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getPrePaySign({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getPrepaySignList());
			},
			searchIt:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.CHARGE_CHANGE_PREPAYSIGN_LOG_URL);
				let param = {
					neighborId:this.neighborId,
					prePaySign:this.prePaySign
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.changeLogList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created() {
			this.queryNeighbors();
		}
	}
</script>

<style>
</style>
